if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    // eslint-disable-next-line no-undef
    class ProductOptions extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.initialize()
      }

      initialize () {
        if (!this.els.trigger || this.els.trigger.elements.length < 2) return

        this.variants = JSON.parse(this.els.variants.element.innerHTML)
      }

      setupListeners () {
        super.setupListeners()

        this.handleTrigger = this.handleTrigger.bind(this)

        this.listeners.add(this, 'click', this.handleTrigger)
      }

      handleVariants () {
        const selectedValues = this.els.select.elements.map(element => element.value)
        const selectedVariant = this.variants.find(variant => {
          return variant.options.every(option => selectedValues.includes(option))
        })

        if (!selectedVariant) return;

        let formVariantID = this.closest('.prd-QuickBuy_Form').querySelector('input[name="id"]')
        formVariantID.value = selectedVariant.id
        let buyButtonVariantId = this.closest('.prd-QuickBuy_Form').querySelector('.js-add-to-bag-form')
        buyButtonVariantId.dataset.id = selectedVariant.id

        const addToCartButton = this.closest('.prd-QuickBuy_Form').querySelector('.js-add-to-bag-form')
        const outOfStockButton = this.closest('.prd-QuickBuy_Form').querySelector('.is-oos')
        const bisModal = document.querySelector('.js-bis');

        !selectedVariant.available ? addToCartButton.style.display = 'none' : addToCartButton.style.display = 'block'
        !selectedVariant.available ? outOfStockButton.style.display = 'flex' : outOfStockButton.style.display = 'none'

        if (bisModal) {
          outOfStockButton.dataset.id = selectedVariant.id
        }
      }

      handleTrigger (event) {
        const trigger = event.target.closest(
          '[data-product-options-el="trigger"]',
        )
        if (!trigger) return

        trigger.setAttribute('aria-pressed', 'true')

        const optionIndex = trigger.dataset.index
        const optionValue = trigger.dataset.value

        const allIndexTriggerEls = [
          ...document.querySelectorAll(
            `${this.els.trigger.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexTriggerEls.forEach(triggerEl => {
          triggerEl.setAttribute(
            'aria-pressed',
            (triggerEl === trigger).toString(),
          )
        })

        allIndexTriggerEls
          .filter(
            triggerEl => this.isQuickBuy(trigger) === this.isQuickBuy(triggerEl),
          )
          .forEach(triggerEl => {
            triggerEl.setAttribute(
              'aria-pressed',
              (triggerEl.dataset.value === optionValue).toString(),
            )
          })

        const allIndexSelectEls = [
          ...document.querySelectorAll(
            `${this.els.select.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexSelectEls
          .filter(
            selectEl => this.isQuickBuy(trigger) === this.isQuickBuy(selectEl),
          )
          .forEach(selectEl => {
            selectEl.value = optionValue
            selectEl.dispatchEvent(new Event('change', { bubbles: true }))
          })

        this.handleVariants();
      }

      isQuickBuy (element) {
        return !!element.closest('[data-section="product-quickbuy"]')
      }
    },
  )
}
